import React from "react";

import "./TableLayout.css";

import { Table } from "antd";



export default function TableLayout({ page = 1, onPageChange = () => { }, isCustomPagination = false, headers, data, status, style = {}, onRowClick = () => { } }) {

    return (

        <Table
            tableLayout="auto"
            loading={status !== "success"}
            columns={headers}
            dataSource={data}
            pagination={{
                pageSize: 8,
                position: ["bottomCenter"],
                className: "pagination",
                pageSizeOptions: [],
                hideOnSinglePage: true,
                ...(isCustomPagination && {
                    current: page,
                    defaultCurrent: page,
                    onChange: (page) => onPageChange(page)
                }
                )
            }}
            className={"table"}
            rowClassName={"row"}
            style={style}
            rowsPerPageOptions={[]}

            onRow={(record, rowIndex) => {
                return {
                    onClick: () => onRowClick(record, rowIndex), // click row
                };
            }}
        />

    )
}